import { PropertyListingType } from "@/enums/property.enum";

export const ListingPropertyPrices: Record<
  PropertyListingType,
  Array<number>
> = {
  [PropertyListingType.RENT]: [
    20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 110000,
    120000, 130000, 140000, 150000, 160000, 170000, 180000, 190000, 200000,
    225000, 250000, 275000, 300000, 350000, 400000, 500000, 750000, 1000000,
  ],
  [PropertyListingType.COMMERCIAL_RENT]: [
    20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 110000,
    120000, 130000, 140000, 150000, 160000, 170000, 180000, 190000, 200000,
    225000, 250000, 275000, 300000, 350000, 400000, 500000, 750000, 1000000,
  ],
  [PropertyListingType.BUY]: [
    300000, 400000, 500000, 600000, 700000, 800000, 900000, 1000000, 1100000,
    1200000, 1300000, 1400000, 1500000, 1600000, 1700000, 1800000, 1900000,
    2000000, 2100000, 2200000, 2300000, 2400000, 2500000, 2600000, 2700000,
    2800000, 2900000, 3000000, 3250000, 3500000, 3750000, 4000000, 4250000,
    4500000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000, 25000000,
    50000000,
  ],
  [PropertyListingType.OFF_PLAN]: [
    300000, 400000, 500000, 600000, 700000, 800000, 900000, 1000000, 1100000,
    1200000, 1300000, 1400000, 1500000, 1600000, 1700000, 1800000, 19000000,
    2000000, 2100000, 2200000, 2300000, 2400000, 2500000, 2600000, 2700000,
    2800000, 2900000, 3000000, 3250000, 35000000, 3750000, 4000000, 4250000,
    4500000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000, 25000000,
    50000000,
  ],
  [PropertyListingType.COMMERCIAL_BUY]: [
    300000, 400000, 500000, 600000, 700000, 800000, 900000, 1000000, 1100000,
    1200000, 1300000, 1400000, 1500000, 1600000, 1700000, 1800000, 19000000,
    2000000, 2100000, 2200000, 2300000, 2400000, 2500000, 2600000, 2700000,
    2800000, 2900000, 3000000, 3250000, 35000000, 3750000, 4000000, 4250000,
    4500000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000, 25000000,
    50000000,
  ],
};
